import React, { useEffect, useState } from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import ContentsTab from "./ContentsTab"
import ProductRecomTab from "./ProductRecomTab"
import BrandRecomTab from "./BrandRecomTab"
import { useLocation, useNavigate } from "react-router-dom"

import { Tab, TabGroup, TabList, TabPanels, TabPanel } from "@headlessui/react"

const Content = props => {
  const location = useLocation()
  const navigate = useNavigate()
  //meta title
  document.title = `${props.t("Content")} | ${process.env.REACT_APP_CMS_TITLE}`

  const [selectedIndex, setSelectedIndex] = useState(0)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const tabParam = params.get("tab")
    if (tabParam === "products") {
      setSelectedIndex(1)
    } else if (tabParam === "brands") {
      setSelectedIndex(2)
    } else {
      setSelectedIndex(0)
    }
  }, [location.search])

  const handleTabChange = index => {
    setSelectedIndex(index)
    let tabValue = "contents"
    if (index === 1) tabValue = "products"
    else if (index === 2) tabValue = "brands"

    navigate(`/contents?tab=${tabValue}`)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Content")}
            breadcrumbItem={props.t("Content")}
          />
          {/* Add your content management content here */}
          <div className="d-flex flex-column gap-4">
            <TabGroup selectedIndex={selectedIndex} onChange={handleTabChange}>
              <TabList>
                <Tab data-testid="contents-tab">โปรโมชัน</Tab>
                <Tab data-testid="recom-product-tab">สินค้าแนะนำ</Tab>
                <Tab data-testid="recom-brand-tab">แบรนด์แนะนำ</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  <ContentsTab />
                </TabPanel>
                <TabPanel>
                  <ProductRecomTab />
                </TabPanel>
                <TabPanel>
                  <BrandRecomTab />
                </TabPanel>
              </TabPanels>
            </TabGroup>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(Content)
